import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, mergeProps as _mergeProps, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, createTextVNode as _createTextVNode, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "mb-4" }
const _hoisted_2 = { class: "invalid-feedback" }
const _hoisted_3 = { class: "mb-4" }
const _hoisted_4 = { class: "p-inputgroup" }
const _hoisted_5 = { class: "invalid-feedback" }
const _hoisted_6 = { class: "mb-4" }
const _hoisted_7 = { class: "container-btn-action" }

import apiUseCase from '@/usecase/apiUseCase'
import SelectAsync from '@/views/components/form/SelectAsync.vue'
import Button from 'primevue/button'
import InputText from 'primevue/inputtext'
import { useForm, Field } from 'vee-validate'
import { computed, watch, onMounted, getCurrentInstance } from 'vue'
import { useStore } from 'vuex'
import * as Yup from 'yup'

const employeePenaltyEndpoint = 'talent/v1/employeePenalties'

export default /*@__PURE__*/_defineComponent({
  __name: 'AdjustmentForm',
  props: {
  data: {
    default: null as any
  },
  existingFineAdjustment: {
    default: [] as any
  },
  currentTotalAmount: {
    default: 0
  },
  penaltyId: {
    default: null as any
  }
},
  setup(__props) {

const props = __props
const dataFineAdjustment = computed(() => props.data)
const penaltyId = computed(() => props.penaltyId)
const existingFineAdjustment = computed(() => props.existingFineAdjustment)
const store = useStore()
const app = getCurrentInstance()
const {
  $toast
} = app!.appContext.config.globalProperties

const getAdjustmentType = (category: any) => {
  const categoryData = category?.PenaltyAdjustmentCategory
    ?? category?.penaltyAdjustmentCategory
    ?? category?.category
    ?? category
  return (
    categoryData?.adjustmentType
    ?? categoryData?.AdjustmentType
    ?? categoryData?.penaltyAdjustmentCategoryAdjustmentType
    ?? categoryData?.PenaltyAdjustmentCategoryAdjustmentType
    ?? ''
  ).toLowerCase()
}

const schema = Yup.object({
  Amount: Yup.number()
    .nullable()
    .typeError('Nominal denda harus berupa angka')
    .test(
      'decrement-within-current-total',
      'Nominal denda pengurang tidak boleh melebihi total denda saat ini',
      function validateDecrementAmount(amount) {
        if (getAdjustmentType(this.parent.PenaltyAdjustmentCategory) !== 'decrement' || amount == null) {
          return true
        }
        return amount <= Number(props.currentTotalAmount)
      }
    )
})

const initialValues = {
  PenaltyAdjustmentCategory: null as any,
  Amount: null as any,
  Description: null as any
}

const { values, errors, setFieldValue, handleSubmit, resetForm } = useForm({
  validationSchema: schema,
  initialValues
})

const getCategoryDetails = (adjustment: any) => {
  const category = adjustment?.PenaltyAdjustmentCategory
    ?? adjustment?.penaltyAdjustmentCategory
    ?? adjustment?.category
    ?? adjustment

  return {
    id: category?.id ?? category?.Id ?? category?.value
      ?? adjustment?.penaltyAdjustmentCategoryId
      ?? adjustment?.PenaltyAdjustmentCategoryId,
    code: category?.code ?? category?.Code
      ?? adjustment?.penaltyAdjustmentCategoryCode
      ?? adjustment?.PenaltyAdjustmentCategoryCode,
    name: category?.name ?? category?.Name
      ?? adjustment?.penaltyAdjustmentCategoryName
      ?? adjustment?.PenaltyAdjustmentCategoryName
  }
}

const isMainFineCategoryLocked = computed(() => (
  dataFineAdjustment.value != null
  && getCategoryDetails(dataFineAdjustment.value).name?.toLowerCase() === 'denda utama'
))

const getAdjustmentId = (adjustment: any) => (
  adjustment?.id
    ?? adjustment?.Id
    ?? adjustment?.adjustmentId
    ?? adjustment?.AdjustmentId
)

const isCategorySelectable = (option: any) => {
  if ((option?.isActive ?? option?.IsActive) !== true) {
    return false
  }

  const options = Array.isArray(existingFineAdjustment.value) ? existingFineAdjustment.value : []
  const optionDetails = getCategoryDetails(option)

  if (options.length === 0) {
    return optionDetails.name?.toLowerCase() === 'denda utama'
  }

  const currentAdjustmentId = getAdjustmentId(dataFineAdjustment.value)
  return !options.some((adjustment: any) => {
    const adjustmentId = getAdjustmentId(adjustment)
    if (
      adjustment === dataFineAdjustment.value
      || (currentAdjustmentId != null
        && adjustmentId != null
        && String(adjustmentId) === String(currentAdjustmentId))
    ) {
      return false
    }

    const categoryDetails = getCategoryDetails(adjustment)
    if (optionDetails.code != null && categoryDetails.code != null) {
      return optionDetails.code === categoryDetails.code
    }
    if (optionDetails.id != null && categoryDetails.id != null) {
      return optionDetails.id === categoryDetails.id
    }
    return categoryDetails.name?.toLowerCase() === optionDetails.name?.toLowerCase()
  })
}

watch(dataFineAdjustment, (data) => {
  if (data != null) {
    const category = data
    const categoryValue = category && typeof category === 'object'
      ? {
        ...category,
        id: category.id ?? category.penaltyAdjustmentCategoryId,
        value: category.value ?? category.penaltyAdjustmentCategoryId,
        label: category.label ?? category.penaltyAdjustmentCategoryName
      }
      : category

    resetForm({
      values: {
        ...initialValues,
        PenaltyAdjustmentCategory: categoryValue,
        Amount: data.Amount ?? data.amount ?? null,
        Description: data.Description ?? data.description ?? null
      }
    })
  }
}, { immediate: true })

const hideSidebar = () => {
  store.dispatch('setShowModal', false)
  store.dispatch('setTitleFormSidebar', null)
}

const onSubmit = handleSubmit(async (dataForm: any) => {
  console.log('dataForm', dataForm)
  store.dispatch('showLoading')
  const payload = {
    penaltyAdjustmentCategoryId: dataForm.PenaltyAdjustmentCategory.value ?? dataForm.PenaltyAdjustmentCategory.id,
    amount: dataForm.Amount ?? 0,
    description: dataForm.Description ?? null
  }

  try {
    const response = await apiUseCase.postOrPut(
      `${employeePenaltyEndpoint}/${penaltyId.value}/adjustments`,
      dataFineAdjustment.value?.id,
      dataFineAdjustment.value?.id ? { id: dataFineAdjustment.value?.id, ...payload } : payload
    )
    const isSuccess = response.error === false || Number(response.code) === 204
    if (isSuccess) {
      $toast.add({
        severity: 'success',
        summary: `Denda berhasil ${dataFineAdjustment.value?.id ? 'diubah' : 'ditambahkan'}!`,
        detail: `Denda pelanggaran berhasil ${dataFineAdjustment.value?.id ? 'diubah' : 'ditambahkan'}!`,
        group: 'bc',
        life: 3000
      })
      store.dispatch('setShowModal', false)
      store.dispatch('setReloadDataList', true)
      store.dispatch('storeRowDataTable', null)
    } else {
      $toast.add({
        severity: 'error',
        summary: `Denda gagal ${dataFineAdjustment.value?.id ? 'diubah' : 'ditambahkan'}`,
        detail: response.message,
        group: 'bc',
        life: 3000
      })
    }
  } catch (error) {
    $toast.add({
      severity: 'error',
      summary: `Denda gagal ${dataFineAdjustment.value?.id ? 'diubah' : 'ditambahkan'}`,
      detail: error,
      group: 'bc',
      life: 3000
    })
  } finally {
    store.dispatch('hideLoading')
  }
})

const onNumericInput = (event: Event, field: any, maxLength: number) => {
  const input = event.target as HTMLInputElement
  input.value = input.value.replace(/\D/g, '').slice(0, maxLength)
  field.onInput(event)
}

onMounted(() => {
  let titleForm = 'Tambah'
  if (store.state.hjpTable.modal.data) {
    titleForm = 'Edit'
  }
  store.dispatch('setTitleFormSidebar', `${titleForm} Denda`)
})

return (_ctx: any,_cache: any) => {
  const _component_Textarea = _resolveComponent("Textarea")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("form", {
      onSubmit: _cache[4] || (_cache[4] = _withModifiers(
//@ts-ignore
(...args) => (_unref(onSubmit) && _unref(onSubmit)(...args)), ["prevent"])),
      class: "form-container"
    }, [
      _createElementVNode("div", _hoisted_1, [
        _cache[5] || (_cache[5] = _createElementVNode("div", { class: "label-text required" }, "Kategori Denda", -1)),
        _createVNode(_unref(Field), { name: "PenaltyAdjustmentCategory" }, {
          default: _withCtx(() => [
            _createVNode(SelectAsync, {
              placeholder: 'Pilih Jenis Pelanggaran',
              modelValue: _unref(values).PenaltyAdjustmentCategory,
              "onUpdate:modelValue": [
                _cache[0] || (_cache[0] = ($event: any) => ((_unref(values).PenaltyAdjustmentCategory) = $event)),
                _cache[1] || (_cache[1] = (val) => _unref(setFieldValue)('PenaltyAdjustmentCategory', val))
              ],
              id: 'penaltyAdjustmentCategory',
              inputId: 'penaltyAdjustmentCategory',
              endpoint: "/talent/v1/penaltyAdjustmentCategories",
              classname: 'custom-select',
              disabled: isMainFineCategoryLocked.value,
              fieldLabel: (v) => `${v.name}`,
              clearable: false,
              searchFields: ['name'],
              selectable: isCategorySelectable
            }, null, 8, ["modelValue", "disabled", "fieldLabel"])
          ]),
          _: 1
        }),
        _createElementVNode("div", _hoisted_2, _toDisplayString(_unref(errors).PenaltyAdjustmentCategory), 1)
      ]),
      _createElementVNode("div", _hoisted_3, [
        _cache[7] || (_cache[7] = _createElementVNode("label", {
          for: "amount",
          class: "label-text required"
        }, "Nominal Denda", -1)),
        _createVNode(_unref(Field), {
          id: "amount",
          name: "Amount",
          class: _normalizeClass(`${_unref(errors).Amount ? 'input-invalid' : ''}`),
          validateOnInput: true
        }, {
          default: _withCtx(({ field }) => [
            _createElementVNode("div", _hoisted_4, [
              _cache[6] || (_cache[6] = _createElementVNode("span", { class: "p-inputgroup-addon" }, _toDisplayString('Rp.'), -1)),
              _createVNode(_unref(InputText), _mergeProps({
                class: `${_unref(errors).Amount ? 'input-invalid' : ''}`,
                id: "amount"
              }, field, {
                "aria-describedby": "base-salary-help",
                placeholder: "0",
                type: "text",
                inputmode: "numeric",
                maxlength: "10",
                onInput: (event) => onNumericInput(event, field, 10)
              }), null, 16, ["class", "onInput"])
            ])
          ]),
          _: 1
        }, 8, ["class"]),
        _createElementVNode("div", _hoisted_5, _toDisplayString(_unref(errors).Amount), 1)
      ]),
      _createElementVNode("div", _hoisted_6, [
        _cache[8] || (_cache[8] = _createElementVNode("div", { class: "label-text" }, "Keterangan Denda", -1)),
        _createVNode(_unref(Field), {
          name: "Description",
          as: "textarea",
          placeholder: "Tulis Keterangan",
          class: ""
        }, {
          default: _withCtx(({ field }) => [
            _createVNode(_component_Textarea, _mergeProps(field, {
              modelValue: _unref(values).Description,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_unref(values).Description) = $event)),
              id: "description",
              autocomplete: "nope",
              autoResize: true,
              ref: "addressRef",
              rows: "3"
            }), null, 16, ["modelValue"])
          ]),
          _: 1
        })
      ]),
      _createElementVNode("div", _hoisted_7, [
        _createVNode(_unref(Button), {
          class: "btn-back mr-2",
          onClick: _cache[3] || (_cache[3] = ($event: any) => (hideSidebar()))
        }, {
          default: _withCtx(() => _cache[9] || (_cache[9] = [
            _createTextVNode("Kembali")
          ])),
          _: 1,
          __: [9]
        }),
        _createVNode(_unref(Button), {
          type: "submit",
          class: "btn-primary mr-1"
        }, {
          default: _withCtx(() => _cache[10] || (_cache[10] = [
            _createTextVNode("Simpan")
          ])),
          _: 1,
          __: [10]
        })
      ])
    ], 32)
  ]))
}
}

})